import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Slider from "react-slick";

import MainContent from "./components/MainContent";
import CloseButton from "../../../../common/CloseButton";
import GettingStarted from "../../../getting-started";

import "./style.css";

function Promo(props) {
    const navigate = useNavigate();
    const sliderRef = useRef(null);
    const [page, setPage] = useState(0);

    useEffect(() => {
        sliderRef?.current?.slickGoTo(page);
    }, [page]);

    const next = () => {
        navigate("/");
    };

    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };

    return (
        <>
            <Slider {...settings} ref={sliderRef}>
                <div id="promo-page" className="flex-c content-area">
                    <MainContent
                        type={props.type}
                        continue={() => {
                            props.close();
                            next();
                        }}
                    />
                </div>

                <div>
                    <GettingStarted bypass={true} />
                </div>
            </Slider>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {})(Promo);
